import { CAPTIONS_ENABLED_KEY } from '../../../../constants';
import { loadPersistedState } from '../../../middleware/storageMiddleware';
import {preferencesActions} from '../../../../actions/preferencesActions';

export type CaptionsEnabledReducerState = boolean;

export const loadDefaultValue = () => loadPersistedState(CAPTIONS_ENABLED_KEY);

export function captionsEnabledReducer(state = true, action?: any): CaptionsEnabledReducerState {
  switch (action.type) {
    case preferencesActions.Captions_Enable:
      return true;
    case preferencesActions.Captions_Disable:
      return false;
    default:
      return state;
  }
}
